(function () {
  'use strict';

  angular
    .module('flyingScheduleReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('flyingScheduleReport', {
        url: '/flying-schedule-report',
        views : {
          'flyingScheduleReportView' : {
            templateUrl: 'flying-schedule-report/views/flying-schedule-report.tpl.html',
            controller: 'FlyingScheduleReportCtrl',
            controllerAs: 'flyingScheduleReport'
          }
        }
      });
  }
}());
